import { NOT_YET_LOADED, hasData } from 'scenes/common/helpers/apiData';
import { ApiData } from 'scenes/common/types';
import { defaultPaymentDetails } from 'scenes/common/flows/paymentDetails/defaults';
import {
  LandlordFlowType,
  LandlordStepType,
  LandlordFunnelState,
  LandlordQuoteDetails,
} from 'scenes/landlord/types';
import {
  toQuoteDetails,
  toCoverOptions,
  toReviewDetails,
} from 'scenes/landlord/api/quote/marshaller';

import { defaultLandlordQuoteDetails } from './quoteDetails/defaults';
import { defaultLandlordCoverOptions } from './coverOptions/defaults';
import { defaultLandlordPolicyDetails } from './policyDetails/defaults';
import { defaultReviewDetails } from './reviewDetails/defaults';

const state = {
  flow: LandlordFlowType.QuoteDetails,
  step: LandlordStepType.CoverTypeSelection,
  [LandlordFlowType.QuoteDetails]: defaultLandlordQuoteDetails,
  [LandlordFlowType.CoverOptions]: defaultLandlordCoverOptions,
  [LandlordFlowType.PolicyDetails]: defaultLandlordPolicyDetails,
  [LandlordFlowType.PaymentDetails]: defaultPaymentDetails,
  [LandlordFlowType.ReviewDetails]: defaultReviewDetails,
  apiResponses: {
    quoteDetails: NOT_YET_LOADED,
    campaign: NOT_YET_LOADED,
    config: NOT_YET_LOADED,
  },
};

export const initialLandlordFunnelState: (
  data?: ApiData<LandlordQuoteDetails>
) => LandlordFunnelState = (data?: ApiData<LandlordQuoteDetails>) => {
  if (data && hasData(data)) {
    return {
      ...state,
      apiResponses: {
        ...state.apiResponses,
        quoteDetails: data,
      },
      step: LandlordStepType.ReviewPolicyStartDate,
      flow: LandlordFlowType.ReviewDetails,
      quoteDetails: toQuoteDetails(data),
      coverOptions: toCoverOptions(data),
      reviewDetails: toReviewDetails(data),
    };
  }
  return state;
};
